import * as angular from 'angular';

export interface StorageFcfsResponseResource
    extends ng.resource.IResourceClass<
        ng.resource.IResource<StorageFcfsResponseDto>
    > {
    get: ng.resource.IResourceMethod<
        ng.resource.IResource<StorageFcfsResponseDto>
    >;
}

function storageFcfsResponseResource(
    $resource: ng.resource.IResourceService,
    API_URL
): StorageFcfsResponseResource {
    return <StorageFcfsResponseResource>$resource(
        API_URL.STORAGE_FCFS_RESPONSE,
        {},
        {
            get: {
                method: 'GET',
                url: API_URL.STORAGE_FCFS_RESPONSE + '/:id'
            }
        }
    );
}

angular
    .module('app')
    .factory('storageFcfsResponseResource', storageFcfsResponseResource);
